import { render, staticRenderFns } from "./OccurrenceMessages.vue?vue&type=template&id=dfa267bc&scoped=true&"
import script from "./OccurrenceMessages.vue?vue&type=script&lang=js&"
export * from "./OccurrenceMessages.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceMessages.vue?vue&type=style&index=0&id=dfa267bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa267bc",
  null
  
)

export default component.exports